/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InventoryStockTransfersDto as DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransfersDto } from '../../models/Digiwork/MaitreD/Pos/DTO/InventoryStockTransfers/inventory-stock-transfers-dto';

export interface GetStockTransfers$Params {
  inventoryId: string;
  searchTerm?: string;
}

export function getStockTransfers(http: HttpClient, rootUrl: string, params: GetStockTransfers$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransfersDto>> {
  const rb = new RequestBuilder(rootUrl, getStockTransfers.PATH, 'get');
  if (params) {
    rb.path('inventoryId', params.inventoryId, {});
    rb.query('searchTerm', params.searchTerm, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransfersDto>;
    })
  );
}

getStockTransfers.PATH = '/api/inventories/{inventoryId}/transfers';
